const ML = [
  {
    id: 1,
    name: "Satvik Nalavade",
    position: "ML Lead",
    image: "https://i.ibb.co/cyM4n6j/satvik-ml.png",
    alt: "Lead_Image",
    col: 5,
    linkedin: "https://www.linkedin.com/in/satviknalavade/",
    instagram: "",
    github: "https://github.com/SatvikNalavade",
    link: "",
  },
  {
    id: 2,
    name: "Aditya Raut",
    position: "ML Member",
    image: "https://i.ibb.co/JptCgc9/profile-pic-7.png",
    alt: "Member_Image",
    col: 5,
    linkedin: "https://www.linkedin.com/in/aditya-raut-4a92631b4/",
    instagram: "https://instagram.com/_adityaraut21",
    github: "https://github.com/AdityaRaut21",
    link: "",
  },
];

export default ML;
